import React, { createContext, useContext, useRef, useState } from 'react'
import enumOptions from '../../enumOptions.json'
import enumConstants from '../../enumConstants.json'
import links from '../../links.json'
import i18n, { t } from 'i18next'
import { InnerAppProvider } from './InnerAppProvider.jsx'

export const AppCtx = createContext({})

export const AppProvider = ({ children, settings }) => {
  const innerProviderRef = useRef()

  const [language, setLanguage] = useState(i18n.language)

  const enumOptionsWithTranslations = Object.assign({}, ...Object.entries(enumOptions)
    .map(([k, v]) => {
      return ({
        [k]: v.map(item => ({
          ...item,
          label: t(item.label)
        }))
      })
    }))

  const value = {
    enumOptions: enumOptionsWithTranslations,
    enumConstants,
    settings,
    language,
    setLanguage,
    links,
    setIsFormDirty: (val) => {
      innerProviderRef.current.setIsFormDirty(val)
    },
    startLoading: (showLoadingIndicator = true) => {
      innerProviderRef.current.setLoading(true, showLoadingIndicator)
    },
    endLoading: () => {
      innerProviderRef.current.setLoading(false)
    }
  }

  return (
    <AppCtx.Provider value={value}>
      {children}
      <InnerAppProvider ref={innerProviderRef} />
    </AppCtx.Provider>
  )
}

export function useApp () {
  const context = useContext(AppCtx)

  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider')
  }

  return context
}
